import { VerticalContainer } from '@/components';
import type { InsurancePartnerOption } from '@/features/profile/model/types';
import { R } from '@/features/profile/resources/ProfileResources.resx';

type SelectInsurancePartnerProps = {
    providers: InsurancePartnerOption[];
};

export const SelectInsurancePartner = ({
    providers,
}: SelectInsurancePartnerProps) => (
    <VerticalContainer spacing="lg">
        <VerticalContainer spacing="sm">
            <h2 id="heading-SelectInsurancePartner">
                {R.SelectInsurancePartner}
            </h2>
            <p className="leading-normal">{R.Profile_Insurance_Intro_Short}</p>
        </VerticalContainer>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-4">
            {providers.map((provider) => (
                <a
                    key={provider.enrollmentUrl}
                    href={provider.enrollmentUrl}
                    className="grid cursor-pointer place-items-center rounded-2xl border border-(--color-border-muted) bg-transparent"
                >
                    <img src={provider.logoPath} alt={provider.name} />
                </a>
            ))}
        </div>
    </VerticalContainer>
);
